exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-form-item[data-v-e696ac94]{margin-bottom:10px}.el-button--text[data-v-e696ac94]{color:#007aff}", "", {"version":3,"sources":["/home/www/deploy/school/src/views/approvals/my/history.vue"],"names":[],"mappings":"AACA,+BACE,kBAAoB,CACrB,AACD,kCACE,aAAe,CAChB","file":"history.vue","sourcesContent":["\n.el-form-item[data-v-e696ac94] {\n  margin-bottom: 10px;\n}\n.el-button--text[data-v-e696ac94] {\n  color: #007aff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e696ac94","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/approvals/my/history.vue
// module id = 2Lk+
// module chunks = 12